import { useTreatments } from '@splitsoftware/splitio-react';
import { TreatmentsWithConfig } from '@splitsoftware/splitio/types/splitio';

export const useFeatureSplit = (splitName: string) => {
  const treatmentObj: TreatmentsWithConfig = useTreatments([splitName]);
  return { treatment: treatmentObj[splitName]?.treatment };
};
